<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section v-if="isDesktop()">
      <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important;">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">Devis</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">Voyage</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 20%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">Devis</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>Voyage</span></h1>
        </div>
        </p>
      </div>
    </section>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div>
      <div class="container" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">Votre <span class="font-weight-bold">devis gratuit</span> en 2 minutes et <span class="font-weight-bold">100% en ligne</span></p> <br>
        </div>
        <br>

        <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">Passager</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">Validation</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title text-center mr-4">Passager</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title text-center mr-4">Validation</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page" v-show="step === 1">

                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Destination&nbsp;:</div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper28" class="field-label">{{i18nFrVoyage.paysVoyage.Headline_1}}</label>
                                <input v-model="pays_domicile" placeholder="Sénégal" id="Stepper28" name="Step8" readonly class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper3" class="field-label">{{i18nFrVoyage.paysVoyage.Headline_2}}</label>
                                <select id="Stepper3" name="Step1" class="field-select" v-model="destination">
                                  <option v-for="item in countries" :key="item" :value="item.PAYS" @change="Stepper1Validator">{{item.PAYS}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                      Suivant
                    </button>
                  </div>
                  <!---->
                </div>

              </div>

              <div class="page" v-show="step === 2">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Durée&nbsp;:</div>
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="field-group field-default">
                                <label for="Stepper25" class="field-label">
                                  {{i18nFrVoyage.dateVoyage.Headline_1}}
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1" placeholder="Cliquer ici" id="Stepper25" @change="yearsDiffDateDepart()" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="field-group field-default">
                                <label for="Stepper25_2" class="field-label">
                                  {{i18nFrVoyage.dateVoyage.Headline_2}}
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" placeholder="Cliquer ici" id="Stepper25_2" @change="yearsDiffDateRetour()" v-model="dateArrivee" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4 mt-1">
                              <div class="field-group field-default">
                                <label for="Stepper26" class="field-label">{{i18nFrVoyage.dateVoyage.Headline_3}}
                                </label>
                                <select v-model="nbpassager" id="Stepper26" name="Step8" class="field-select">
                                  <option v-for="item in NombrePassagers" :key="item" :value="item">{{item}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Retour
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="Stepper2Validator()" type="button" class="wizard-btn">
                      Suivant
                    </button>
                  </div>
                  <!---->
                </div>
              </div>

              <div class="page" v-show="step === 3">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step3" aria-hidden="true" aria-labelledby="step-Step3" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Infos passagers&nbsp;:</div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="field-group field-default">
                                <label for="Stepper6" class="field-label">
                                  Date de naissance du passager
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker :disabled-date="disabledAfterTodayBirth" class="field-input ml-2 mb-1 mt-1" id="Stepper6" @change="PassengerAgeCalculation()" placeholder="Cliquer ici" v-model="dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                                <div class="input-group-append mt-3">
                                  <div class="input-group-text" v-if="listPassager.length < nbpassager">
                                    <button @click="CreateListPassager" type="button" class="wizard-btn">
                                      {{i18nFrVoyage.titre_btn_ajouter}}
                                    </button>
                                  </div>

                                  <div class="input-group-text ml-3" v-show="ChangeAgePassager">
                                    <button @click="PassengerAgeChange" type="button" class="wizard-btn">
                                      {{i18nFrVoyage.titre_btn_changer}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-1">
                              <div class="field-group field-default">
                                <label for="Stepper7" class="field-label">
                                  Âge du passager
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <input v-model="age" readonly id="Stepper7"  name="Step3" class="field-input">
                                  <div class="input-group-append">
                                    <div class="input-group-text">an(s)</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                      <!----> <!---->
                    </div>
                  </div>
                </div>
                <div class="fields mt-5">
                  <table class="table table-striped table-bordered">
                    <thead>
                    <tr>
                      <th style="font-size:18px">{{i18nFrVoyage.passagersVoyage.Headline_2}}</th>
                      <th style="font-size:18px">Âge</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="psg in listPassager" :key="psg.id">
                      <td class="font-weight-bold">{{psg.adulte_enfant}}</td>
                      <td class="font-weight-bold">{{psg.age_passager}} ans</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Retour
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button v-if="listPassager.length==nbpassager" @click="nextToFourStep()" type="button" class="wizard-btn">
                      Suivant
                    </button>
                  </div>
                  <!---->
                </div>
              </div>

              <div class="page review_page" v-show="step === 4">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step10" aria-hidden="true" aria-labelledby="step-Step10" class="wizard-tab-container">
                    <div>
                      <div class="justify-content-center row field-title font-weight-bold" style="color:#ffa409">
                        Récapitulatif Devis
                      </div>
                      <div class="field-title font-weight-bold">
                        Personne(s) enregistrée(s)&nbsp;:
                      </div>
                      <div class="fields" v-for="(vyg,index) in tableauVoyage" :key="index">
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper29" class="field-label">{{i18nFrVoyage.entetTableeauRec[0]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="text" id="Stepper29" name="Step10" :value="vyg.pays_domicile" class="field-input pac-target-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper30" class="field-label">{{i18nFrVoyage.entetTableeauRec[1]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="text" id="Stepper30" name="Step10" :value="vyg.destination" class="field-input pac-target-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper31" class="field-label">{{i18nFrVoyage.entetTableeauRec[2]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="tel" id="Stepper31" name="Step10" :value="vyg.dateDepart" class="field-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper32" class="field-label">{{i18nFrVoyage.entetTableeauRec[3]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="text" id="Stepper32" name="Step10" :value="vyg.dateArrivee" class="field-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper33" class="field-label">{{i18nFrVoyage.entetTableeauRec[4]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="text" id="Stepper33" name="Step10" :value="vyg.nbpassager" class="field-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                        <div class="field-group row align-items-center">
                          <div class="col-lg-4"><label for="Stepper34" class="field-label">{{i18nFrVoyage.entetTableeauRec[5]}}</label></div>
                          <div class="col-lg-8 field-default">
                            <input disabled type="text" id="Stepper34" name="Step10" v-for="(passager,index) in listPassager" :key="index" :value="passager.adulte_enfant + ' ' + passager.age_passager + ' an(s)'" class="field-input">
                            <div class="field-error">
                              <!---->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="fields">
                        <div class="field-title font-weight-bold">
                          Choix assureurs&nbsp;:
                        </div>
                        <div class="field-group row field-bank" v-for="assure in listeAssureurs" :key="assure._id">
                          <div class="btn-choice col-sm-3 col-4" v-if="assure.societe=='SONAM GENERALE ASSURANCES'">
                              <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe" class="field-input" disabled>
                              <label :for="assure.societe" class="field-label" :label="assure.societe">
                                <img :src="assure.logo" :alt="assure.societe" height="50">
                                <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{assure.societe.substr(0, 5)}}</p>
                              </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div role="tabpanel" id="Step11" aria-hidden="true" aria-labelledby="step-Step11" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Période de couverture&nbsp;:</div>
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper38" class="field-label">Durée de la garantie
                                  <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                <div class="input-group rate-loan">
                                  <input @keypress="onlyNumber" min="1" type="number" id="Stepper38" placeholder="Durée de la garantie" name="Step11" class="field-input" v-model="duree_contrat" @keyup="dateDiff" disabled>
                                  <div class="input-group-append">
                                    <div class="input-group-text">jours</div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-sm-4">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper39" class="field-label">Date d'effet
                                  <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                <div class="input-group rate-loan">
                                  <date-picker :disabled-date="disabledBeforeToday" id="Stepper39" class="field-input ml-2 mb-1 mt-1" placeholder="Cliquer ici" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>

                            <div class="col-sm-4">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper40" class="field-label">Date d'échéance
                                  <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                <div class="input-group rate-loan">
                                  <input disabled placeholder="Date d'échéance" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div role="tabpanel" id="Step12" aria-hidden="true" aria-labelledby="step-Step12" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="field-title font-weight-bold">Modalités de remboursement&nbsp;:</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12 field-radio field-radio-center">
                              <div class="btn-choice">
                                <input v-model="remboursable" type="radio" value="remboursable" id="remboursable" name="modalite" class="field-input">
                                <label for="remboursable" class="field-label btn-choice-hide-dot">
                                  <img src="../assets/img/icones/rembourse.png" alt="remboursable" width="50">Remboursable</label>
                              </div>
                              <div class="btn-choice">
                                <input v-model="remboursable" type="radio" value="Non_remboursable" id="non_remboursable" name="modalite" class="field-input">
                                <label for="non_remboursable" class="field-label btn-choice-hide-dot">
                                  <img src="../assets/img/icones/non-rembourse.png" alt="non remboursable" width="50">Non Remboursable</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Retour
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="saveVoyage()" type="button" class="wizard-btn">
                      Valider
                    </button>
                  </div>
                  <!---->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
          <div class="mt-5 container" style="background:#FAFAFA">
            <div class="row" style="background:#FAFAFA">

              <div class="col-md-10" style="background:#FAFAFA">
                <div class="form" style="background:#FAFAFA">
                  <div class="page" v-show="step === 1">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                        <div>

                          <div class="fields">
                            <div class="field-title">Destination&nbsp;:</div>
                            <div class="field-group field-default mt-3 mb-4 mb-sm-0">
                              <label for="Stepper28_mobile" class="field-label">{{i18nFrVoyage.paysVoyage.Headline_1}}</label>
                              <input v-model="pays_domicile" placeholder="Sénégal" id="Stepper28_mobile" name="Step8" readonly class="field-input">
                            </div>
                            <div class="field-group field-default mb-4 mb-sm-0" >
                              <label for="Stepper3_mobile" class="field-label">{{i18nFrVoyage.paysVoyage.Headline_2}}</label>
                              <select id="Stepper3_mobile" name="Step1_mobile" class="field-select" v-model="destination">
                                <option v-for="item in countries" :key="item" :value="item.PAYS" @change="Stepper1Validator">{{item.PAYS}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                          Suivant
                        </button>
                      </div>
                      <!---->
                    </div>

                  </div>

                  <div class="page" v-show="step === 2">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="9" aria-hidden="true" aria-labelledby="step-Step8_mobile" class="wizard-tab-container">
                        <div>
                          <div class="loan-group loan-group-0">
                            <div class="fields">
                              <div class="field-title">Durée&nbsp;:</div>
                              <div class="row">
                                <div class="col-sm-4">
                                  <div class="field-group field-default">
                                    <label for="Stepper25_mobile" class="field-label">
                                      {{i18nFrVoyage.dateVoyage.Headline_1}}
                                      <!---->
                                    </label>
                                    <div class="input-group value-loan">
                                      <date-picker :disabled-date="disabledAfterToday" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_mobile" @change="yearsDiffDateDepart()" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="field-group field-default">
                                    <label for="Stepper25_mobile" class="field-label">
                                      {{i18nFrVoyage.dateVoyage.Headline_2}}
                                      <!---->
                                    </label>
                                    <div class="input-group value-loan">
                                      <date-picker :disabled-date="disabledBeforeToday" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_mobile" @change="yearsDiffDateRetour()" v-model="dateArrivee" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="field-group field-default mt-3">
                                    <label for="Stepper26_mobile" class="field-label">{{i18nFrVoyage.dateVoyage.Headline_3}}
                                    </label>
                                    <select v-model="nbpassager" id="Stepper26_mobile" name="Step8_mobile" class="field-select">
                                      <option v-for="item in NombrePassagers" :key="item" :value="item">{{item}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="Stepper2Validator()" type="button" class="wizard-btn">
                          Suivant
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page" v-show="step === 3">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step9_mobile" aria-hidden="true" aria-labelledby="step-Step9_mobile" class="wizard-tab-container">
                        <div>
                          <div class="loan-group loan-group-0">
                            <div class="fields">
                              <div class="field-title">Infos passagers&nbsp;:</div>
                              <div class="row">
                                <div class="col-sm-4">
                                  <div class="field-group field-default">
                                    <label for="Stepper25_1_mobile" class="field-label">
                                      Date de naissance du passager
                                      <!---->
                                    </label>
                                    <div class="input-group value-loan">
                                      <date-picker :disabled-date="disabledAfterTodayBirth" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_1_mobile" @change="PassengerAgeCalculation()" v-model="dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                    </div>
                                    <div class="input-group-append mt-3">
                                      <div class="input-group-text" v-if="listPassager.length < nbpassager">
                                        <button @click="CreateListPassager" type="button" class="wizard-btn">
                                          {{i18nFrVoyage.titre_btn_ajouter}}
                                        </button>
                                      </div>

                                      <div class="input-group-text ml-3" v-show="ChangeAgePassager">
                                        <button @click="PassengerAgeChange" type="button" class="wizard-btn">
                                          {{i18nFrVoyage.titre_btn_changer}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="field-group field-default">
                                    <label for="Stepper27_1_mobile" class="field-label">
                                      Âge du passager
                                      <!---->
                                    </label>
                                    <div class="input-group value-loan">
                                      <input v-model="age" id="Stepper27_1_mobile" readonly name="Step9_mobile" class="field-input">
                                      <div class="input-group-append">
                                        <div class="input-group-text">an(s)</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="fields mt-5">
                      <table class="table table-striped table-bordered">
                        <thead>
                        <tr>
                          <th style="font-size:13px">{{i18nFrVoyage.passagersVoyage.Headline_2}}</th>
                          <th style="font-size:13px"> Âge</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="psg in listPassager" :key="psg.id">
                          <td class="font-weight-bold">{{psg.adulte_enfant}}</td>
                          <td class="font-weight-bold">{{psg.age_passager}} ans</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button v-if="listPassager.length==nbpassager" @click="nextToFourStep()" type="button" class="wizard-btn">
                          Suivant
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page review_page" v-show="step === 4">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step10_mobile" aria-hidden="true" aria-labelledby="step-Step10_mobile" class="wizard-tab-container">
                        <div>
                          <div class="justify-content-center row field-title" style="color:#ffa409">
                            Récapitulatif Devis
                          </div>
                          <div class="field-title">
                            Personne(s) enregistrée(s)&nbsp;:
                          </div>
                          <div class="fields" v-for="(vyg,index) in tableauVoyage" :key="index">
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper29_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[0]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input disabled type="text" id="Stepper29_mobile" name="Step10_mobile" :value="vyg.pays_domicile" class="field-input pac-target-input">
                                <div class="field-error">
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper30_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[1]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input disabled type="text" id="Stepper30_mobile" name="Step10_mobile" :value="vyg.destination" class="field-input pac-target-input">
                                <div class="field-error">
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper31_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[2]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input disabled type="tel" id="Stepper31_mobile" name="Step10_mobile" :value="vyg.dateDepart" class="field-input">
                                <div class="field-error">
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper32_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[3]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input disabled type="text" id="Stepper32_mobile" name="Step10_mobile" :value="vyg.dateArrivee" class="field-input">
                                <div class="field-error">
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper33_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[4]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input disabled type="text" id="Stepper33_mobile" name="Step10_mobile" :value="vyg.nbpassager" class="field-input">
                                <div class="field-error">
                                  <!---->
                                </div>
                              </div>
                            </div>
                            <div class="field-group row align-items-center">
                              <div class="col-lg-4"><label for="Stepper37_mobile" class="field-label">{{i18nFrVoyage.entetTableeauRec[5]}}</label></div>
                              <div class="col-lg-8 field-default">
                                <input style="margin-bottom:4px" v-for="(passager,index) in listPassager" :key="index" disabled  type="text" id="Stepper37_mobile" name="Step10_mobile" :value="passager.adulte_enfant + ' ' + passager.age_passager + ' an(s)'" class="field-input">
                              </div>
                            </div>
                          </div>
                          <div class="fields">
                            <div class="field-title">
                              Choix assureurs&nbsp;:
                            </div>
                            <div class="field-group row field-bank" v-for="assure in listeAssureurs" :key="assure._id">
                              <div class="btn-choice col-sm-3 col-4" v-if="assure.societe=='SONAM GENERALE ASSURANCES'">
                                <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe" class="field-input" disabled>
                                <label :for="assure.societe" class="field-label" :label="assure.societe">
                                  <img :src="assure.logo" :alt="assure.societe" height="50">
                                  <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{assure.societe.substr(0, 5)}}</p>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div role="tabpanel" id="Step11_mobile" aria-hidden="true" aria-labelledby="step-Step11_mobile" class="wizard-tab-container">
                        <div>
                          <div class="loan-group loan-group-0">
                            <div class="fields">
                              <div class="field-title">Période de couverture&nbsp;:</div>
                              <div class="row">
                                <div class="col-sm-4">
                                  <div class="field-group field-default mb-4 mb-sm-0">
                                    <label for="Stepper38_mobile" class="field-label">Durée de la garantie
                                      <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                    <div class="input-group rate-loan">
                                      <input @keypress="onlyNumber" min="1"  type="number" id="Stepper38_mobile" placeholder="Durée de la garantie" name="Step11_mobile" class="field-input" v-model="duree_contrat" disabled @keyup="dateDiff">
                                      <div class="input-group-append">
                                        <div class="input-group-text">Jours</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-sm-4">
                                  <div class="field-group field-default mb-4 mb-sm-0">
                                    <label for="Stepper39_mobile" class="field-label">Date d'effet
                                      <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                    <div class="input-group rate-loan">
                                      <date-picker :disabled-date="disabledBeforeToday" id="Stepper39_mobile" :editable="false" class="field-input mb-1 mt-1" placeholder="Cliquer ici" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-sm-4">
                                  <div class="field-group field-default mb-4 mb-sm-0">
                                    <label for="Stepper40_mobile" class="field-label">Date d'échéance
                                      <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                    <div class="input-group rate-loan">
                                      <input disabled placeholder="Date d'échéance" v-model="dateEcheance" id="Stepper40_mobile" name="Step11_mobile" class="field-input">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div role="tabpanel" id="Step12_mobile" aria-hidden="true" aria-labelledby="step-Step12_mobile" class="wizard-tab-container">
                        <div>
                          <div>
                            <div class="fields">
                              <div class="field-title">Modalités de remboursement&nbsp;:</div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input v-model="remboursable" value="remboursable" type="radio" id="remboursable_mobile" name="modalite_mobile" class="field-input">
                                  <label for="remboursable_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../assets/img/icones/rembourse.png" alt="remboursable" class="mr-4 mr-md-0">
                                    <p>Remboursable</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input v-model="remboursable" type="radio" value="Non_remboursable" id="non_remboursable_mobile" name="modalite_mobile" class="field-input">
                                  <label for="non_remboursable_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../assets/img/icones/non-rembourse.png" alt="non remboursable" class="mr-4 mr-md-0">
                                    <p>Non Remboursable</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="saveVoyage()" type="button" class="wizard-btn">
                          Valider
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Api from '../services/Api'
import store from '../store/store'
import LoginForm from './auth/Login'
import configVoyage from '../common/configVoyage.json'
import PushInDataLayer from '../services/TagManager'

export default {
  name: 'Voyage',
  components: {
    LoginForm
  },
  data() {
    return {
      expand: false,
      ChangeAgePassager: false,
      disable_rn: false,
      remboursable: null,
      Non_remboursable: null,
      datePickerPassengerBirth: false,
      dateNaissance: null,
      voyageDialogToBlok: false,
      disabled: false,
      switch1: false,
      selected: [],
      showLoginForm: false,
      step: 1,
      age: '',
      ageDepart: '',
      ageArrivee : '',
      nbpassager: null,
      countries: [],
      countriesSn: 'Sénégal',
      tableauVoyage: [],
      garanties: [],
      i18nFrVoyage: null,
      autres_garanties: [],
      adulte_enfant: null,
      destination: '',
      pays_domicile: '',
      VoyageToUpdate: null,
      listeAssureurs: [],
      popupAddGaranties: false,
      dateSouscription: new Date().toISOString().substr(0, 10),
      dateEffet: null, //new Date().toISOString().substr(0, 10),
      dateEcheance: null, //new Date().toISOString().substr(0, 10),
      dateDepart: null,
      dateArrivee: null,
      datePickerArrivee: false,
      datePickerDepart: false,
      datePickerEffet: false,
      duree_contrat: '',
      NombrePassagers: ['1'],
      listPassager: [],
      proprietaire: '',
      assureurs: [],
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'error'
      }, // Customized options for error toast
      branche: 'Voyage',
      zone_garantie: '',
      showPeriode: false,
      notif: false,



      neant: 'N.A',
      date: new Date().toISOString().substr(0, 10),
    }
  },
  methods: {
    disabledBeforeToday(date) {
      const today = dayjs(this.dateDepart).add(+1, 'day')
      return date < today;
    },
    disabledAfterToday(date) {
      const today = dayjs(new Date()).add(-1, 'day')
      return date < today;
    },
    disabledAfterTodayBirth(date) {
      const today = dayjs(new Date()).add(-1, 'day')
      return date > today;
    },
    nextToFourStep(){
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthThirt');
      this.step = 4
      for (let ref of this.listeAssureurs) {
        let obj;
        obj = ref.societe;
        if (obj === 'SONAM GENERALE ASSURANCES'){
          this.assureurs = obj
        }
      }
    },

    BacktoFirstStep(){
      this.step = 1
      document.getElementById("testup").classList.remove('widthSecond');

    },


    BacktoSecondStep(){
      this.step = 2
      document.getElementById("firstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthThirt');

    },
    BacktoThirstStep(){
      this.step = 3
      document.getElementById("testup").classList.remove('widthFour');
      this.ChangeAgePassager = true

    },

    yearsDiffDateDepart() {
      const date1 = dayjs(this.dateDepart);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.ageDepart = daydiff;

      if (this.ageDepart > 0) {
        this.ageDepart = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
        this.dateDepart = null

      } else if (this.ageDepart <= 29) {
        this.an = this.annee_mois = 'jour(s)'

      } else if (this.ageDepart >= 30, this.ageDepart <= 360) {
        let year = Math.floor(this.ageDepart / 30);
        this.ageDepart = year;
        this.an = this.annee_mois = 'mois'

      } else if (this.ageDepart >= 360) {
        let year = Math.floor(this.age / 360);
        this.ageDepart = year;
        this.annee = year;
        this.year = this.ageDepart;
        this.an = this.annee_mois = 'an(s)'
      }

    },
    yearsDiffDateRetour() {
      const date1 = dayjs(this.dateArrivee);
      const date2 = dayjs(this.dateDepart);
      let daydiff = date2.diff(date1, 'days');

      this.ageArrivee = daydiff;

      if (this.ageArrivee > 0) {
        this.ageArrivee = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date postérieure à la date de départ! ', this.ToastTabError)
        this.dateArrivee = null

      }else {
        this.daysDiff()
      }

    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    /*codePays: function (mark) {
         if(typeof this.countries=='object'){
                let selMarque = _.where(this.countries, { 'destination': mark.destination });
                this.code = selMarque;
                this.code = mark.destination;
                this.destination = this.code
        }
    },*/

    /*checkSwitchControl() {
        let dayD = dayjs(new Date()).add(+1, 'day').format('YYYY-MM-DD')
        if (this.dateDepart == new Date().toISOString().substr(0, 10)) {
            this.disable_rn = true
        }else if(this.dateDepart == dayD){
            this.disable_rn = true
        }else {
            this.disable_rn = false
        }
    },*/

    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },
    daysDiff() {
      const date1 = dayjs(this.dateDepart);
      const date2 = dayjs(this.dateArrivee);
      let daydiff = date2.diff(date1, 'day');
      this.duree_contrat = daydiff + 1;
      this.dateDiff()
    },

    /*retour button a la page recap devis montrant button changer devis                                                                                                                                                                                                                                                                                                                                                                                                                      */
    ReturnTochange() {
      this.e1 = 3
      this.ChangeAgePassager = true
    },
    PassengerAgeChange() {
      let Unpassager = {};
      if (this.listPassager.length === parseInt(this.nbpassager)) {

        if (this.age < 18) {
          Unpassager.adulte_enfant = 'Enfant'
        } else if (this.age >= 18) {
          Unpassager.adulte_enfant = 'Adulte'
        }

        if (this.age != Unpassager.age_passager) {
          Unpassager.age_passager = this.age
          Unpassager.dateNaissance = this.dateNaissance
          this.listPassager.pop(Unpassager)
          this.listPassager.push(Unpassager)
          this.age = this.age
          //this.PassedToNext()
          document.getElementById("firstStep").classList.add('checked');
          document.getElementById("testup").classList.add('widthThirt');
          this.step = 4
        }
      }
    },

    /* On affiche le popup pour ajouter des garanties supplementaires a un vehicule(item) */
    AddGaranties(vyg) {
      this.VoyageToUpdate = vyg;
      this.popupAddGaranties = true
    },

    /*==========VALIDATION ELEMENTS SETEPPER 1===========*/
    Stepper1Validator() {
      if (this.pays_domicile) {
        if (this.destination) {
          if (typeof this.pays_domicile == 'string') {

            if (this.pays_domicile == this.destination) {
              this.$toasted.show('Pays de destination doit être différent du pays de depart', this.ToastTabError)
            } else {
              this.next()
              document.getElementById("testup").classList.add('widthFirst');

            }

          } else if (typeof this.pays_domicile == 'object') {
            this.destinat = true;
            if (this.pays_domicile.PAYS == this.destination.PAYS) {
              this.$toasted.show('Pays de destination doit être différent du pays de depart', this.ToastTabError)
            } else {
              this.next()
            }

          }

        } else {
          this.$toasted.show('Pays de destination obligatoire', this.ToastTabError)
        }
      } else {
        this.$toasted.show('Pays de départ obligatoire !', this.ToastTabError)
      }

    },

    /*==========VALIDATION ELEMENTS SETEPPER 2===========*/
    Stepper2Validator() {
      if (this.dateDepart) {
        if (this.dateArrivee) {
          if (this.nbpassager) {
             if(dayjs(this.dateArrivee).diff(this.dateDepart,"day")>=1){
                this.next()
                document.getElementById("testup").classList.add('widthSecond');
              }else{
                this.$toasted.show("Plage de date non conforme !", this.ToastTabError)
              }
          } else {
            this.$toasted.show("Veuillez saisir le nombre de passager!", this.ToastTabError)
          }

        } else {
          this.$toasted.show("Date de retour obligatoire !", this.ToastTabError)
        }
      } else {
        this.$toasted.show("Date de départ obligatoire !", this.ToastTabError)
      }
    },

    incrementPassager() {
      this.nbpassager++
    },

    decrementPassager() {
      this.nbpassager--
    },

    /*=========Initialisation des donneespour affichage recap========*/
    RecapUserData: function () {
      const devisVoyage = {
        'pays_domicile': this.pays_domicile,
        'destination': this.destination,
        'nbpassager': this.nbpassager,
        'dateNaissance': this.dateNaissance,
        'garanties': this.garanties,
        'autres_garanties': this.autres_garanties,
        'dateDepart': this.dateDepart,
        'dateArrivee': this.dateArrivee,

      };
      this.tableauVoyage.push(devisVoyage)
    },
    PassedToNext() {
      this.RecapUserData();
      this.e1 = 5
    },
    /*====Nettoyage du formulaire apres soumission pour recap====*/
    ClearForm: function () {
      this.countries = '';
      this.countriesSn = '';
      this.tableauVoyage = [];
      this.destination = '';
      this.pays_domicile = '';
      this.assurs = '';
      this.proprietaire = '';
      this.listeAssureurs = {};
      this.autres_garanties = [];
      this.garanties = [];
      this.assureurs = []
    },

    dateDiff: function () {
      if (this.dateDepart === '' && this.duree_contrat === '') this.dateEcheance = '';
      let inter = dayjs(this.dateDepart).add((this.duree_contrat-1), 'day').format('YYYY-MM-DD');
      this.dateEcheance = dayjs(inter).format('YYYY-MM-DD')
      this.yearsDiffDateDepart()
    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },

    isDesktop: function () {
      if (screen.width > 760) {
        return true
      } else {
        return false
      }
    },

    /*====Recuperation de la liste des Pays depuis API====*/
    getListePays: function () {
      Api().get('pays')
          .then(response => {
            this.countries = response.data

          })
          .catch(err => {
            err
          })
    },

    /*====Recuperation de la liste des Partners depuis API====*/
    getListePartenaire: function () {
      Api().get('partenaire/partners/voyage')
          .then(response => {
            this.listeAssureurs = response.data.partenaires
          })
          .catch(err => {
            err
          })
    },

    displayPeriode: function () {
      if (this.dateEffet && this.dateEcheance) {
        this.showPeriode = true
      }
    },

    /*====REMPLISAAGE DES PASSAGERS POUR DEVIS VOYAGE====*/
    CreateListPassager: function () {
      let Unpassager = {};

      if (this.age) {
        if (this.age < 18) {
          Unpassager.adulte_enfant = 'Enfant'
        } else if (this.age >= 18) {
          Unpassager.adulte_enfant = 'Adulte'
        }
        Unpassager.age_passager = this.age;
        Unpassager.dateNaissance = this.dateNaissance
        this.listPassager.push(Unpassager);
        this.age = null;

        if (this.listPassager.length === parseInt(this.nbpassager)) {
          this.PassedToNext()

          for (let ref of this.listeAssureurs) {
            let obj;
            obj = ref.societe;
            if (obj === 'SONAM GENERALE ASSURANCES'){
              this.assureurs = obj
            }
          }

          this.next()
          document.getElementById("firstStep").classList.add('checked');
          document.getElementById("testup").classList.add('widthThirt');
        } else {
          this.age = null;
          this.adulte_enfant = null
        }
      } else {
        this.$toasted.show('Tous les champs sont obligatoires !', this.ToastTabError)
      }

    },
    /*Passenger Age calculation based on passenger birthday*/
    PassengerAgeCalculation() {
      const date1 = dayjs(this.dateNaissance);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age < 0) {
        this.age = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date de naissance postérieure à la date actuelle! ', this.ToastTabError)
        this.dateNaissance = null

      } else {
        let TodayDate = new Date()
        this.age = dayjs(TodayDate).diff(this.dateNaissance, 'year')

        let PassengerObject = {
          dateNaissance: this.dateNaissance,
          age: this.age
        }
        localStorage.setItem('passenger-birthady-age', JSON.stringify(PassengerObject))
      }
    },

    /*===============ENVOI DES DATA A L'API ===================*/
    saveVoyage: function () {
      if (!store.state.isUserLoggedIn)
      {
        const val = {
          position :'quote-creation',
          event:'login_intent'
        }
        this.$loginPopupPosition.position='quote-creation'
        PushInDataLayer(val)
        this.showLoginForm = true
      } else
      {
        if (this.duree_contrat) {
          if (this.dateDepart) {
            if (this.assureurs.length > 0) {

              if (this.remboursable) {
                document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthFive');
                for (let index = 0; index < this.countries.length; index++) {
                  if (this.countries[index].PAYS === this.destination) {
                    this.destination = this.countries[index]
                  }
                }
                const Voyage = {
                  user: store.state.user._id,
                  createur: store.state.user._id,
                  destination: this.destination,
                  nbpassager: this.nbpassager,
                  dateEffet: this.dateDepart,
                  dateNaissance: this.dateNaissance,
                  clientid: store.state.user._id,
                  dateEcheance: this.dateEcheance,
                  duree: this.duree_contrat,
                  dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                  mode_remboursement: this.remboursable,
                  dateDepart: this.dateDepart,
                  dateArrivee: this.dateArrivee,
                  assureurs: this.assureurs,
                  branche: this.branche,
                  listPassager: this.listPassager,
                  garanties: this.garanties,
                  plateforme:"Front",
                  autres_garanties: this.autres_garanties
                };

                if (typeof this.pays_domicile == 'string') {
                  Voyage.pays_domicile = this.pays_domicile
                } else if (typeof this.pays_domicile == 'object') {
                  Voyage.pays_domicile = this.pays_domicile.PAYS
                }

                Api().post('devis/add', Voyage)
                    .then(result => {

                      let GtmVal = {
                        branche : 'voyage',
                        entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                        insurer_number: this.assureurs.length,
                        event:'quote_creation'
                      }
                      PushInDataLayer(GtmVal)

                      if (result.data.message)
                      {
                        this.notif = true;
                        this.$store.dispatch('setDevis', result.data);
                        this.$router.push({
                          name: 'listDevis'
                        })
                      }
                    })
              } else {
                this.$toasted.show("Modalités de remboursement obligatoire !", this.ToastTabError)
              }

            } else {
              this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
            }
          } else {
            this.$toasted.show("Date d'effet obligatoire ! ", this.ToastTabError)
          }

        } else {
          this.$toasted.show('Durée du voyage obligatoire !', this.ToastTabError)
        }

      }
    }
  },
  created() {
    this.i18nFrVoyage = configVoyage.French;
    this.GarantiesBase = configVoyage.French.Garanties;
    this.TyeSecuVol = configVoyage.French.Type_securite_vol;
    this.Autres_garanties = configVoyage.French.Autres_garanties
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.displayPeriode();
    this.getListePartenaire();
    this.getListePays();
    this.pays_domicile = this.countriesSn;

  },
  computed: {
    selectAll: {
      get: function () {
        return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
      },
      set: function (value) {
        const assureurs = [];

        if (value) {
          this.listeAssureurs.forEach(function (assure) {
            assureurs.push(assure.societe);
          });
        }

        this.assureurs = assureurs;
      }
    }
  }

}
</script>

<style lang="less" scoped>
@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";



.form {
  background-color: #fff;
  padding: 1.5rem;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}




html {
  background-color: #1a1a1a;
  overflow: hidden;
}
.middle {
  width: auto;
  text-align: center;
  /* Made by */
}
.middle h1 {
  font-family: "Inter", sans-serif;
  color: #fff;
}
.middle input[type="radio"] {
  display: none;
}
.middle input[type="radio"]:checked + .box {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
  color: #29323a;
}
.middle input[type="radio"]:checked + .box span {
  color: #29323a;
  transform: translateY(70px);
}
.middle input[type="radio"]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.middle .box {
  width: 220px;
  height: 150px;
  border-radius: 12px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
  font-size: 10px;
  border: 1px solid #d9dee3;
  font-family: Open Sans,sans-serif;
  font-weight: 900;
}
.middle .box:hover {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
}
.middle .box:hover span {
  color: #29323a;
}

.middle .box:active {
  transform: translateY(10px);
}
.middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  padding-top: 15%;
  transition: all 300ms ease;
  font-size: 1.5em;
  user-select: none;
  color: #29323a;
}
.middle .box span:before {
  font-size: 1.2em;
  font-family: FontAwesome;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: #fff;
}
.middle p {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.middle p a {
  text-decoration: underline;
  font-weight: bold;
  color: #fff;
}
.middle p span:after {
  content: "\f0e7";
  font-family: FontAwesome;
  color: yellow;
}

.widthFirst{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:17.55556%;
}
.widthSecond{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:33.11112%;
}
.widthThirt{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:49.11112%;
}
.widthFour{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:33.11112%;
}
.widthFive{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:100%;
}
















.paralax-cover-image {
  background-image: url('../assets/img/assurance/voyage.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}


.paralax-cover-image_mobile {
  background-image: url('../assets/img/assurance/voyage_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 50% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
</style>
